// Minimal registration: register ASAP so Chrome sees SW during installability checks.
export function register() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/service-worker.js`, { scope: "/" })
      .catch((error) => {
        console.error("Service Worker registration failed:", error);
      });
  }
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((r) => r.unregister());
    });
  }
}